import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

import image from '../../../assets/images/payroll-cards/header.webp'
import notification from '../../../assets/images/wage-access/header-notification.svg'
import figure from '../../../assets/images/shapes/red-bottom-left.svg'
import Animations from '../../../utils/animations'
import Paths from '../../../utils/paths'
import useStyles from '../PayrollCards.styles'

export default function PayrollCardsHeader () {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <div className={classes.headerContainer} onClick={() => navigate(Paths.CONTACT)}>
      <img src={image} alt='header-image' className={classes.headerImage} />
    </div>
  )
}
